import React, { useEffect, useState } from "react";
import api from "../../../../api";
import "./Library.css";
import DynamicBanner from "../../include/DynamicBanner";
import LatestNewsMarquee from "./Partials/LatestNewsMarquee";
import StickyNav from "./Partials/StickyNav";

const Collections = () => {
  const [data, setData] = useState(null);

  // Banner state
  const [bannerTitle, setBannerTitle] = useState("");
  const [bannerImagesDesktop, setBannerImagesDesktop] = useState([]);
  const [bannerImagesMobile, setBannerImagesMobile] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(
          "/api/sitepages/about-us/librarycollections"
        );

        /** -------------------------
         *  BANNER DATA
         * ------------------------- */
        const banner = response.data.banner_data;

        if (banner) {
          setBannerTitle(banner.title || "");

          // 🔥 DIRECT IMAGE URL (NO BASE PREFIX)
          const desk = banner.desktop_images || [];
          const mob = banner.mobile_images || [];

          setBannerImagesDesktop(desk);
          setBannerImagesMobile(mob);
        }

        /** -------------------------
         *  MAIN SECTION
         * ------------------------- */
        const main = response.data.groups.find(
          (g) => g.main_section
        )?.main_section;

        if (main) {
          setData({
            ...main,
            tabs: Object.values(main.tabs), // Convert object to array
          });
        }
      } catch (err) {
        console.error("Error fetching library collections:", err);
      }
    };

    fetchData();
  }, []);

  if (!data) return <></>;

  return (
    <>
      <section className="library-page pb_80">

        {/* ---------------- BANNER ---------------- */}
        {(bannerImagesDesktop.length > 0 || bannerImagesMobile.length > 0) && (
          <DynamicBanner
            title={bannerTitle}
            bgImage={bannerImagesDesktop}
            bgImageMobile={bannerImagesMobile}
          />
        )}

        <LatestNewsMarquee />
        <StickyNav />

        <div className="container">
          <div className="nss-container1">

            <div className="sec-title text-center">
              <h2>{data.title}</h2>
            </div>

            {/* ---------------- TABS ---------------- */}
            <ul
              className="nav nav-tabs justify-content-center flex-sm-row flex-nowrap"
              role="tablist"
            >
              {data.tabs.map((tab, i) => (
                <li className="nav-item" key={tab.id}>
                  <button
                    className={`nav-link ${i === 0 ? "active" : ""}`}
                    data-bs-toggle="pill"
                    data-bs-target={`#${tab.id}`}
                    type="button"
                  >
                    {tab.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* ---------------- CONTENT ---------------- */}
          <div className="content-area">
            <div className="tab-content tab-library-style">
              {data.tabs.map((tab, i) => (
                <div
                  className={`tab-pane tab-css fade list ${
                    i === 0 ? "show active" : ""
                  }`}
                  id={tab.id}
                  key={tab.id}
                >
                  <h3>{tab.title}</h3>
                  <p>{tab.description}</p>

                  <table className="timings-table table table-bordered">
                    <thead>
                      <tr>
                        {tab.table.headers.map((header, idx) => (
                          <th key={idx}>{header}</th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {tab.table.rows.map((row, rIdx) => (
                        <tr key={rIdx}>
                          {row.map((cell, cIdx) => (
                            <td key={cIdx}>{cell}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ))}
            </div>
          </div>
        </div>

      </section>
    </>
  );
};

export default Collections;
